import FormSwitchWithText from "../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import Styles from "../scss/formFields.module.scss"
import { AddItemsButton } from "../components/menu/products/extras/ui/AddItemsButton";
import { IMenuFormData } from "../components/manageMenu/types";
import IMenuItemBody from "../interfaces/IMenuItemBody";
import { DeleteItems } from "../yoello-lib/modules/dynamicForms/CustomFormComponents/DeleteItems";
import { ICallAPIFunction } from "../yoello-lib/modules/API2/types";
import { TFunction } from "i18next";
import ISubCategory from "../components/menu/categories/ISubCategory";
import { PRODUCTS_MANAGE_MENU_URL } from "../const/URL.const";
import { FilterOptionsType } from "../yoello-lib/modules/components/UI/Lists/AdvancedChecklist/state/AdvancedChecklist.actions";
import { ManageMenuFormDialog } from "../components/manageMenu/ManageMenuFormDialog";

export function manageMenuForm(props: any, menuItemsList: IMenuItemBody[], isLoading: boolean, onSecondDialogSubmit: (selectedMenuItemsList: IMenuItemBody[],
    changedMenuItemsList: IMenuItemBody[]) => void, selectedMenuItems: IMenuItemBody[], onDeleteSelectedItem: (id: string) => void, manageMenuApi: ICallAPIFunction<IMenuFormData>,
    isCreate: boolean, t: TFunction, subcategories: ISubCategory[],closeAllModals:(path:string)=>void, itemData?: IMenuFormData , onFailedInteraction?:Function): IDynamicFormRow[] {

    const filterOptions: FilterOptionsType[] = [{
        label: t("misc.subcategory"),
        optionLabelKey: "subcategory_name",
        optionFilterKey: "id",
        itemFilterKey: "subcategory_id",
        filterOptionsList:subcategories || [],
    }];

    let formRows: IDynamicFormRow[] = [
        {
            label: "manageMenu.form.menuName",
            keyName: "name_public",
            Component: FormTextBox,
            disabled: false,
            registerOptions:
            {
                required: true,
            },
            inputProperties: {
                placeholder: "",
                InputProps: {
                    type: "text",
                },
            },
            gridColumnOptions: {
                formCol: 8
            },
            className: Styles.TextBoxWithAddon
        }, {
            label: "manageMenu.form.enabled",
            Component: FormSwitchWithText,
            keyName: "enabled",
            gridColumnOptions: {
                formCol: 4
            },
            className: Styles.FormSwitchWithText
        },
        {
            label: "manageMenu.form.menuInternalName",
            keyName: "name_private",
            Component: FormTextBox,
            disabled: false,
            inputProperties: {
                placeholder: "",
                InputProps: {
                    type: "text",
                },
            },
            gridColumnOptions: {
                formCol: 12
            },
            className: Styles.TextBoxWithAddon
        },
        {
            label: "manageMenu.form.description",
            keyName: "description",
            Component: FormTextBox,
            disabled: false,
            inputProperties: {
                type: 'text',
                multiline: true,
                rows: 4,
            },
            gridColumnOptions: {
                formCol: 12
            },
        }, {
            Component: AddItemsButton,
            label: t("manageMenu.form.ManageItemsInMenu", {
                menuName: itemData && itemData?.name_public?.length > 0 ? itemData?.name_public : "Menu"
            }),
            keyName: "selectedMenuItemIDs",
            formProps: {
                ...props,
                secondLabel: t("manageMenu.form.ClickToAddItems"),
                formData: itemData,
                dialogTitle: t("manageMenu.form.ManageItemsInMenu", {
                    menuName: itemData && itemData?.name_public?.length > 0 ? itemData?.name_public : "Menu"
                }),
                selectedMenuItems: selectedMenuItems,
                setPreviousData: true,
                itemsList: selectedMenuItems,
                onDeleteSelectedItem: onDeleteSelectedItem,
                selectedItemsText: t("manageMenu.form.ItemsInGroup"),
                isMenus: true,
                prevModal: "menu",
                parentPath: PRODUCTS_MANAGE_MENU_URL,
                formDataKey: "itemData",
                dialogProps: {
                    items: menuItemsList,
                    isLoading: isLoading,
                    onSubmit: onSecondDialogSubmit,
                    // selectedItems: selectedMenuItems,
                    filterOptions,
                    hasSubmitCancelButtons:true,
                    isVirtualizeList:true
                }
            }
        },
    ];

    if (!isCreate && itemData) {
        formRows.splice(3, 0, {
            label: "delete.label",
            Component: DeleteItems,
            formProps: {
                rawProps: props,
                item: itemData,
                callAPI: manageMenuApi, 
                ParentComponent: ManageMenuFormDialog,
                keyLabel: 'menu',
                isArrayModal: true, 
                closeAllModalsOnSubmit: true,
                closeAllModals: ()=>closeAllModals(props.routePath),
                onFailedInteraction:onFailedInteraction
            },
            keyName: "delete",
        })

    }

    return formRows
}



